document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll(
    ".mobile-menu .menu-item-has-children"
  );

  menuItems.forEach((item) => {
    const link = item.querySelector("a"); // Parent link
    const submenu = item.querySelector(".sub-menu"); // Submenu
    const toggleIcon = item.querySelector(".with-icon"); // Dropdown toggle icon

    // Allow parent link to navigate as usual
    link.addEventListener("click", function (event) {
      // If the click is on the toggle icon, prevent navigation and toggle the dropdown
      if (event.target.closest(".with-icon")) {
        event.preventDefault(); // Prevent navigation when clicking the icon
        item.classList.toggle("is-open"); // Toggle 'is-open' class
      }
    });

    // Allow submenu links to navigate as usual
    submenu.querySelectorAll("a").forEach((submenuLink) => {
      submenuLink.addEventListener("click", function (event) {
        // Do not prevent default for submenu links
        // Clicking these links will navigate as expected
        event.stopPropagation(); // Stop event from bubbling to parent
      });
    });
  });
});
